import React from "react";
import { useHistory } from "react-router-dom";
import {
  paymentQuery,
  paymentRequest,
  addPrepayDish,
  getStaffToken,
  getHistoryOrder,
  addDish as addDishRequest,
} from "../apis";
import {
  LoadingContext,
  ApiResponseContext,
  ConfirmPageContext,
} from "../contexts";
import { API_PaymentQuery } from "../interfaces";
import { ShoppingCartHelper, getPayway } from "../utils";
import strings from "../strings";

import {getHostByShopNameAndOrderType} from "../utils/index" 

const usePayment = () => {
  const history = useHistory();
  const { resetCart } = ShoppingCartHelper();
  const [, responseDispatch] = React.useContext(ApiResponseContext);

  const [, loadingDispatch] = React.useContext(LoadingContext);
  const [, confirmPageDispatch] = React.useContext(ConfirmPageContext);

  const query = async ({ channel }) => {
    const orderId = localStorage.getItem("redpaymentsOrderId");
    if (orderId === null || orderId === "") {
      responseDispatch({
        type: "SET",
        payload: {
          addDishResponse: {
            code: 501,
            message: strings.notFoundOrderId,
          },
        },
      });
      return { code: "9999" };
    } else {
      const values: API_PaymentQuery = {
        channel,
        hostname: getHostByShopNameAndOrderType("hkyuebaby", "order"),
        orderId: localStorage.getItem("redpaymentsOrderId") || "",
      };

      const resp = await paymentQuery(values);

      return resp;
    }
  };

  const request = async ({ tableCode }) => {
    let tableAvailibility = false;

    try {
      loadingDispatch({ type: "SET", payload: { global: true, login: false } });

      const getTableResp = await getHistoryOrder({ tableCode });

      if (getTableResp.data.code === "0") {
        tableAvailibility = true;
        if (getTableResp.data.data.salesorderId === "string") {
          localStorage.setItem(
            "aupos_customer_order_salesorder_id",
            getTableResp.data.data.salesorderId
          );
        }
      }

      if (getTableResp.data.code === "3000") {
        tableAvailibility = true;
      }
    } catch (error) {
      if (error && error.response && error.response.data.code === "3000") {
        tableAvailibility = true;
      }
    }

    if (!tableAvailibility) {
      loadingDispatch({
        type: "SET",
        payload: { global: false, login: false },
      });
      responseDispatch({
        type: "SET",
        payload: {
          addDishResponse: {
            code: 501,
            message: strings.formatString(
              strings.tableNotAvailableToPay,
              tableCode
            ),
          },
        },
      });
      // localStorage.removeItem("redpaymentsOrderId");
      // show login modal
      confirmPageDispatch({ type: "SET", payload: { showStaffLogin: false } });
      return;
    }

    const date = new Date();
    const timestamp = date.getTime();
    const order_id = `${timestamp}${Math.floor(Math.random() * 100)}`;
    localStorage.setItem("redpaymentsOrderId", order_id);
    const channel = getPayway();

    const resp = await paymentRequest({
      channel,
      total: "0.01",
      currency: "AUD",
      item: "Food",
      order_id,
      params: "{'buyerId':135066060473426942}",
      quantity: "1",
      payway: channel === "ALIPAY" ? "WAP" : undefined,
      hostname: window.location.hostname,
      returnUrl: `${window.location.protocol}//${window.location.hostname}/confirm/${tableCode}`,
    });

    if (resp.status === "success") {
      if (channel === "ALIPAY") {
        const content = JSON.parse(resp.message);
        confirmPageDispatch({
          type: "SET",
          payload: { payForm: content.data.payForm },
        });
        history.push(`${process.env.PUBLIC_URL}/complete/alipayform`);
      } else {
        window.location.href = resp.approvel_url;
      }
    } else {
      alert(resp.message);
    }
  };

  const addDish = async ({ payway, tableCode }) => {
    const cartList = JSON.parse(
      localStorage.getItem("aupos_customer_order_shopping_cart")!
    );
    const getSalesorderLines = () => {
      return JSON.stringify(
        cartList.map((cli) => {
          return {
            stockId: cli.stockId,
            taste: cli.selectedOptions
              ? cli.selectedOptions
                  .filter((y) => y.type === "TASTE")
                  .map((x) => {
                    return {
                      stockId: x.stockId,
                      price: x.price,
                      quantity: 1,
                    };
                  })
              : [],
            extra: cli.selectedOptions
              ? cli.selectedOptions
                  .filter((y) => y.type === "EXTRA")
                  .map((x) => {
                    return {
                      stockId: x.stockId,
                      price: x.price,
                      quantity: 1,
                    };
                  })
              : [],
            sizeLevel:
              cli.selectedSize && cli.selectedSize.sizeLevel
                ? cli.selectedSize.sizeLevel
                : cli.sizeLevels[0].sizeLevel || 0,
            quantity: cli.quantity,
            comments: getComments(cli.comments) || "",
            price:
              cli.selectedSize && cli.selectedSize.price
                ? cli.selectedSize.price
                : cli.sizeLevels[0].price,
          };
        })
      );
    };

    const getComments = (value) => {
      let result = value || "";
      const orderComments = localStorage.getItem(
        "aupos_customer_order_orderComments"
      );
      if (orderComments && orderComments !== "") {
        return result === "" ? orderComments : `${result},${orderComments}`;
      } else {
        return result;
      }
    };

    const getTokenResp = await getStaffToken({ barcode: "1" });
    const token = getTokenResp.data.data;

    let existingSalesorderId = null;
    const getTableResp = await getHistoryOrder({ tableCode });
    if (
      getTableResp.data.data !== undefined &&
      typeof getTableResp.data.data.salesorderId === "number"
    ) {
      existingSalesorderId = getTableResp.data.data.salesorderId;
    }

    loadingDispatch({ type: "SET", payload: { global: true, login: false } });

    try {
      let resp;
      if (existingSalesorderId === null) {
        resp = await addPrepayDish({
          gotoKitchen: true,
          guestNo: "2",
          isPaid: false,
          paymentDetail: JSON.stringify([{ paymentType: payway, amount: 250 }]),
          token,
          salesorderLines: getSalesorderLines(),
          tableCode,
        });
      } else {
        const origResp = await addDishRequest({
          salesorderId: existingSalesorderId,
          salesorderLines: getSalesorderLines(),
          tableCode,
          token,
        });
        resp = origResp.data;
      }
      if (resp.code == "0") {
        let currentDate = new Date();
        localStorage.setItem(
          "aupos_customer_order_salesorderId",
          JSON.stringify({
            date: currentDate.getTime(),
            value: resp.salesorderId,
          })
        );
        confirmPageDispatch({
          type: "SET",
          payload: { showStaffLogin: false },
        });
        responseDispatch({
          type: "SET",
          payload: { addDishResponse: { code: 200, message: "success" } },
        });
        loadingDispatch({
          type: "SET",
          payload: { global: false, login: false },
        });
        resetCart();
      } else if (resp.code == "4000") {
        /*token invaild */
        // handle known error
        loadingDispatch({
          type: "SET",
          payload: { global: false, login: false },
        });
        responseDispatch({
          type: "SET",
          payload: { addDishResponse: { code: 400, message: "fail" } },
        });
        // show login modal
        confirmPageDispatch({
          type: "SET",
          payload: { showStaffLogin: false },
        });
      } else {
        loadingDispatch({
          type: "SET",
          payload: { global: false, login: false },
        });
        responseDispatch({
          type: "SET",
          payload: { addDishResponse: { code: 300, message: "fail" } },
        });
        // show login modal
        confirmPageDispatch({
          type: "SET",
          payload: { showStaffLogin: false },
        });
      }
    } catch (error) {
      console.log(error);
      responseDispatch({
        type: "SET",
        payload: { addDishResponse: { code: 300, message: "fail" } },
      });
      loadingDispatch({
        type: "SET",
        payload: { global: false, login: false },
      });
      confirmPageDispatch({ type: "SET", payload: { showStaffLogin: false } });
    }
  };

  return {
    query,
    request,
    addDish,
  };
};

export default usePayment;
